import { ClassificationCode } from "@/types/code.types";
import { ArticleInfo } from "@interface/articleInfo.interface";

import { ArticleInfoResponse } from "./articleInfo.interface";

export const adaptArticleInfoData = (
  info: ArticleInfoResponse,
): ArticleInfo => {
  if (
    info?.labelId ||
    info?.classificationManual === "regulatoryLabel" ||
    window.location.pathname.includes("regulatory")
  ) {
    return {
      ...info,
      classification: info?.classification,
      classificationAi:
        (info?.classificationAi as ClassificationCode) || "regulatoryLabel",
      classificationManual:
        (info?.classificationManual as ClassificationCode) || "regulatoryLabel",
      classificationAiName: info?.classificationAiName,
      classificationManualName: info?.classificationManualName,
      pressTitle: info?.labelName || info?.pressTitle || "",
      pressUrl: info?.pressUrl || "",
      isReviewRequired: false,
      reviewIdList: [],
    };
  }

  if (
    info?.publicationNumber ||
    info?.classificationManual === "patent" ||
    window.location.pathname.includes("patent")
  ) {
    return {
      ...info,
      classification: info?.classification,
      classificationAi:
        (info?.classificationAi as ClassificationCode) || "patent",
      classificationManual:
        (info?.classificationManual as ClassificationCode) || "patent",
      classificationAiName: info?.classificationAiName,
      classificationManualName: info?.classificationManualName,
      pressTitle: info?.title || info?.pressTitle || "",
      pressUrl: info?.pressUrl || "",
      isReviewRequired: false,
      reviewIdList: [],
    };
  }

  if (info?.publicationId || window.location.pathname.includes("publication")) {
    return {
      ...info,
      affiliation:
        info?.affiliation?.filter((data) => data !== "")?.join(", ") || "",
      classificationAi: (info?.topicType as ClassificationCode) || "P999",
      classificationManual: (info?.topicType as ClassificationCode) || "P999",
      classificationAiName: "Publication",
      classificationManualName: "Publication",
      pressTitle: info?.title || "",
      pressUrl: info?.publicationUrl || "",
    };
  }

  if (info?.registryUrl || info?.registryDate) {
    return {
      ...info,
      pressTitle: info?.title || "",
      pressUrl: info?.registryUrl || "",
      classificationAi: info.registryAgency as ClassificationCode,
      classificationManual: info.registryAgency as ClassificationCode,
      id: info.id,
      registryId: info.registryId,
      registryDate: info.registryDate,
      registryAgency: info.registryAgency,
    };
  }
  const targetReviewRequiredInformationList =
    info?.reviewInformationList?.filter(({ deleted }) => deleted !== true);

  const isCtgRoute = window.location.pathname.includes("ctg");

  return {
    ...info,
    reviewIdList:
      targetReviewRequiredInformationList?.map((data) =>
        Number(data.reviewId),
      ) || [],
    isReviewRequired: targetReviewRequiredInformationList?.length > 0,
    // CTG 라우트인데 분류가 비어있으면(빈/없는 데이터) "ctg"로 채워
    // ClassificationNotDefined 풀페이지 차단 대신 graceful 렌더되게 함.
    // 정상 데이터면 API 분류값을 그대로 유지하고, reviewIdList도 보존됨.
    ...(isCtgRoute && {
      classificationAi: (info?.classificationAi as ClassificationCode) || "ctg",
      classificationManual:
        (info?.classificationManual as ClassificationCode) || "ctg",
    }),
  };
};
